import { Typography } from "@mui/material";
import { Chart, PieSeries } from '@devexpress/dx-react-chart-material-ui';
import { Animation } from '@devexpress/dx-react-chart';
import { ChartBox, ChartText } from "./ApartmentsHelpers";

export const ChartSection = ({ loading }) => {
    return (
        <ChartBox>
            <ChartText>
                <Typography variant="h2">Загрузка</Typography>
                <Typography variant="h1">{loading}%</Typography>
            </ChartText>
            <Chart
                data={[
                    { value: loading },
                    { value: 100 - loading },
                ]}
                width={200}
                height={200}
            >
                <PieSeries
                    valueField="value"
                    argumentField="value"
                    outerRadius={1}
                    innerRadius={0.65}
                />
                <Animation />
            </Chart>
        </ChartBox>
    );
};
